import React from 'react';
import { Link } from 'react-router-dom';
import PageSEO from '../components/PageSEO';
import SiteHeader from '../components/SiteHeader';
import SiteFooter from '../components/SiteFooter';

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-aspen-warm-ivory dark:bg-aspen-night-sage flex flex-col">
      <PageSEO
        title="Page Not Found — Ask Aspen"
        description="The page you are looking for does not exist. Navigate back to Ask Aspen to find what you need."
        canonicalPath="/404"
        noindex
      />
      <SiteHeader />

      <div className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-lg">
          <p className="text-8xl font-bold text-aspen-sage-teal/30 mb-4">404</p>
          <h1 className="text-3xl font-bold text-aspen-deep-eucalyptus dark:text-aspen-pearl mb-4">
            Page Not Found
          </h1>
          <p className="text-lg text-aspen-sage-teal dark:text-aspen-gentle-teal mb-8">
            The page you are looking for does not exist or has been moved. Let us help you find what you need.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center px-6 py-3 bg-aspen-vibrant-blue hover:bg-aspen-vibrant-blue/90 text-white font-semibold rounded-xl transition-colors min-h-[48px]"
            >
              Go to Homepage
            </Link>
            <Link
              to="/app"
              className="inline-flex items-center justify-center px-6 py-3 border-2 border-aspen-sage-teal text-aspen-sage-teal hover:bg-aspen-sage-teal hover:text-white font-semibold rounded-xl transition-colors min-h-[48px]"
            >
              Launch App
            </Link>
          </div>
          <div className="mt-12">
            <p className="text-sm text-aspen-sage-teal dark:text-aspen-gentle-teal mb-4">Or explore these pages:</p>
            <div className="flex flex-wrap justify-center gap-3">
              <Link to="/how-it-works" className="text-aspen-vibrant-blue hover:underline text-sm">How It Works</Link>
              <Link to="/features" className="text-aspen-vibrant-blue hover:underline text-sm">Features</Link>
              <Link to="/pricing" className="text-aspen-vibrant-blue hover:underline text-sm">Pricing</Link>
              <Link to="/faq" className="text-aspen-vibrant-blue hover:underline text-sm">FAQ</Link>
              <Link to="/blog" className="text-aspen-vibrant-blue hover:underline text-sm">Blog</Link>
              <Link to="/contact" className="text-aspen-vibrant-blue hover:underline text-sm">Contact</Link>
            </div>
          </div>
        </div>
      </div>

      <SiteFooter />
    </div>
  );
};

export default NotFoundPage;
